import { type ClassValue, clsx } from "clsx";
import { format } from "date-fns";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function formatFullName(
	firstName?: string | null,
	lastName?: string | null,
): string {
	return [firstName, lastName].filter(Boolean).join(" ");
}

export function formatPaymentMethod(method: string): string {
	return method
		.replaceAll("_", " ")
		.replaceAll(/\b\w/g, (c) => c.toUpperCase());
}

export function calculateAge(birthday: string | undefined): number | null {
	if (!birthday) return null;
	const birthDate = new Date(birthday);
	if (Number.isNaN(birthDate.getTime())) return null;
	const today = new Date();
	let age = today.getFullYear() - birthDate.getFullYear();
	const monthDelta = today.getMonth() - birthDate.getMonth();
	if (
		monthDelta < 0 ||
		(monthDelta === 0 && today.getDate() < birthDate.getDate())
	) {
		age -= 1;
	}
	// Future birthdays land here; treat as missing rather than show negative years.
	return age < 0 ? null : age;
}

export function formatDateTime(epochMs: number): string {
	return format(new Date(epochMs), "dd/MM/yyyy, HH:mm");
}
